import React from 'react';
import { createPortal } from 'react-dom';

const Snackbar = ({
  node, sticky, children, onCloseSnackbar
}) => {
  const classNames = ['snackbar'];
  let contents = children;

  if (sticky) {
    classNames.push('sticky u-flex u-flexJustifyBetween d-flex justify-content-between');
    contents = <div className="u-flexGrow1">{children}</div>;
  }

  return (
    createPortal(
      <div className={classNames.join(' ')}>
        {contents}
        {sticky &&
          (
            <button
              onClick={onCloseSnackbar}
              className="clickable u-flexShrink0 btn-plaintext"
              type="button"
              aria-label="Close message panel"
            >
              <svg className="icon">
                <use xlinkHref="#icon-close" />
              </svg>
            </button>
          )}
      </div>,
      node
    )
  );
};

const SnackbarContext = React.createContext(() => {});

const withSnackbarProvider = (Component, snackbarNode) => {
  const componentWithSnackbar = class extends React.Component {
    state = { snackbarMessage: null };

    showToastMessage = (message, options) => {
      let sticky = false;

      if (options) sticky = options.sticky;

      this.setState({ sticky, snackbarMessage: message });
    };

    handleClose = () => {
      this.setState({ snackbarMessage: '' });
    };

    render() {
      let node;
      if (typeof snackbarNode === 'function') node = snackbarNode();
      else node = snackbarNode;

      const { handleClose } = this;
      const { sticky, snackbarMessage } = this.state;

      return (
        <SnackbarContext.Provider value={this.showToastMessage}>
          {/* eslint-disable react/jsx-props-no-spreading */}
          <Component {...this.props} />
          {snackbarMessage &&
            <Snackbar node={node} sticky={sticky} onCloseSnackbar={handleClose}>{snackbarMessage}</Snackbar>}
        </SnackbarContext.Provider>
      );
    }
  };

  return componentWithSnackbar;
};

export { Snackbar as default, SnackbarContext, withSnackbarProvider };
